import { Injectable, Type } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { ValUtilsService } from './val-utils.service';

@Injectable()
export class ValRouteUtilsService {
    constructor(private _u: ValUtilsService) { }

    public isChildRoute = (root: ActivatedRouteSnapshot, parentComponentName: string): boolean => {
        let ret = false;
        if (root) {
            if (root.children) {
                root.children.forEach(ch => {
                    if (ret === false) {
                        if (this._u.isObject(ch.component)) {
                            if ((ch.component as any).name === parentComponentName) {
                                ret = true;
                            } else {
                                ret = this.isChildRoute(ch, parentComponentName);
                            }
                        } else {
                            ret = this.isChildRoute(ch, parentComponentName);
                        }
                    }
                });
            }
        }
        return ret;
    }

    public findParentName = (root: ActivatedRouteSnapshot) => {
        if (root) {
            if (this._u.isObject(root.component)) {
                return (root.component as any).name;
            } else {
                this.findParentName(root.parent);
            }
        }
    }

    public constructUrl = (root: ActivatedRouteSnapshot, toComponent: Type<any> = null): string => {
        let url = '';
        if (root) {
            let stop = false;
            root.pathFromRoot.forEach(p => {
                if (!stop) {
                    p.url.forEach(u => {
                        url += '/' + u.path;
                    });
                }
                if (p.component === toComponent) {
                    stop = true;
                }
            });
        }
        return url;
    }
}
